import React, { FormEvent, useState } from 'react';

import apiClient from '../services/api';
import { User } from '../types/api';
import './LoginPage.css';

interface LoginPageProps {
  onLoggedIn: (user: User) => void;
}

export default function LoginPage({ onLoggedIn }: LoginPageProps) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: FormEvent): Promise<void> {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const user = await apiClient.post<User>('/accounts/login/', { username, password });
      onLoggedIn(user);
    } catch (err) {
      setError((err as Error).message || 'Login failed');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <img
          src="/megaphony-logo.png"
          alt="Megaphony"
          className="login-logo"
        />
        <p className="subtitle">
          Self-hosted, multi-platform social posting. Draft once, normalize per
          platform, and publish to Bluesky, Instagram, Facebook, and TikTok from
          one place — bring your own credentials.
        </p>
        <form onSubmit={handleSubmit}>
          <label>
            Username
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
              required
            />
          </label>
          <label>
            Password
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </label>
          {error && <div className="login-error">{error}</div>}
          <button type="submit" disabled={submitting} className="primary">
            {submitting ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
      <footer className="login-footer">
        <a
          href="https://www.bluewizard.com"
          target="_blank"
          rel="noopener noreferrer"
          className="login-footer-brand"
        >
          <img
            src="/bluewizard-logo.gif"
            alt="Blue Wizard"
            className="login-footer-logo"
          />
        </a>
        <p className="login-footer-copy">
          Megaphony is Copyright &copy; 2026{' '}
          <a
            href="https://www.bluewizard.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Blue Wizard
          </a>
        </p>
        <nav className="login-footer-legal">
          <a href="/terms.html">Terms of Service</a>
          <span aria-hidden>·</span>
          <a href="/privacy.html">Privacy Policy</a>
        </nav>
      </footer>
    </div>
  );
}
